import { languageAtom, type ValidLanguage } from "@/modules/l10n/i18n.store.ts";
import { formatDistance, type Locale } from "date-fns";
import { enUS } from "date-fns/locale/en-US";
import { atom } from "jotai";

// NB: We do not use dynamic `import` for the English locale, since date-fns seems to statically import it in `defaultLocale.js` anyway
const enLoader = () => Promise.resolve(enUS);

const localeLoaders: Record<ValidLanguage, () => Promise<Locale>> = {
    // XXX: Should probably consider "en-GB" etc. as well
    en: enLoader,

    et: async () => (await import("date-fns/locale/et")).et,
    es: async () => (await import("date-fns/locale/es")).es,
    fi: async () => (await import("date-fns/locale/fi")).fi,
    fr: async () => (await import("date-fns/locale/fr")).fr,
    bn: async () => (await import("date-fns/locale/bn")).bn,
    hi: async () => (await import("date-fns/locale/hi")).hi,
    id: async () => (await import("date-fns/locale/id")).id,
    th: async () => (await import("date-fns/locale/th")).th,

    "en-x-arr": enLoader,
    "zz-pseudo": async () => (await import("date-fns/locale/el")).el,
};

const dateFnsLocaleAtom = atom(async (get) => {
    const language = get(languageAtom);
    const loader = localeLoaders[language];
    return loader ? await loader() : undefined;
});

/** Automatically localized version of date-fns `formatDistance` */
export const formatDistanceAtom = atom(async (get) => {
    const locale = await get(dateFnsLocaleAtom);
    const fn: typeof formatDistance = (d1, d2, o) =>
        formatDistance(d1, d2, {
            locale,
            ...o,
        });
    return fn;
});
